import { UsageTypeEnum } from 'app-components/flux/categories/categoriesTypes';
import { useField } from 'app-components/flux/categories/categoryFormHooks';
import QChoiceTextField from 'components/QuickenControls/QChoiceChips/QChoiceTextField';
import React from 'react';

const initialCap = (value: string) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
const items = [UsageTypeEnum.PERSONAL, UsageTypeEnum.BUSINESS].map((name) => initialCap(name));

const TaxInfoUsageType = ({ parentUsageType }: { parentUsageType?: string }) => {
  const { value, onValueChange } = useField('usageType');

  return (
    <QChoiceTextField
      text='Usage'
      QChoiceChipsProps={{
        items,
        selectedItems: [initialCap(value)],
        onSelected: (items) => onValueChange(items[0].toUpperCase() as UsageTypeEnum),
        disabled: !!parentUsageType,
      }}
    />
  );
};

export default TaxInfoUsageType;
